import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Box, Divider, IconButton, Paper, Skeleton } from "@mui/material";
import { usePersistentState } from "../../contexts/global-context";
import { GetLocalStorage } from "../../utils/local-storage";
import { STRING } from "../../resources/string";
import NumberFormat from "../../components/number-format";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import APIS from "../../config/api";
import { POST } from "../../config/https";

export default function Review({ data }: ReviewProps) {
  const [state, dispatch]: any = usePersistentState();
  const [resetAmount, setResetAmount] = useState(false);
  const checkOutData = GetLocalStorage("CheckOutData");
  const couponInfo = GetLocalStorage("CouponInfo");
  const checkOutDataEventDetail = GetLocalStorage("CheckOutDataEventDetail");
  const [couponCodeRemove, setCouponCodeRemove] = useState("");
  const paymentTypeId = GetLocalStorage("paymentTypeId");

  const handleCheckOutAmount = async (paymentTypeId: any) => {
    const CouponInfo = GetLocalStorage("CouponInfo");
    let checkTemp = checkOutData;

    let ticketConfigs = checkTemp?.final?.map((x: any) => {
      return {
        id: x?.id,
        qty: x?.qty,
      };
    });
    let param = {
      couponCode: couponCodeRemove,
      email: CouponInfo?.email,
      eventId: state?.Event?.id,
      ticketConfigs: ticketConfigs,
      paymentType: paymentTypeId,
    };
    await POST(APIS.CHARGE_CALCULATION, param)
      .then((res: any) => {
        if (res?.isSuccess) {
          let temp = {
            ...checkOutData,
            totalTicketPrices: res?.result?.total,
            tax: res?.result?.tax,
            serviceFees: res?.result?.serviceFees,
            subTotal: res?.result?.subTotal,
            couponDiscountPrice: res?.result?.couponDiscountPrice,
            feeBreakdown: res?.result?.feeBreakdown,
          };
          dispatch({ CheckOutData: temp });
          dispatch({ couponInfo: res?.result });
          localStorage.setItem("CheckOutData", JSON.stringify(temp));
          localStorage.setItem("CouponInfo", JSON.stringify(res?.result));
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const calculateSubTotal = () => {
    if (data && data.final) {
      return data.final.reduce(
        (subTotal: number, product: any) => subTotal + product.amount,
        0
      );
    }
    return 0;
  };

  const subTotal = calculateSubTotal();

  const calculateFinalTotal = () => {
    let total = subTotal;
    if (Array.isArray(checkOutData)) {
      checkOutData.forEach((checkOutData: any) => {
        if (checkOutData.price) {
          total -= parseFloat(checkOutData.price);
        }
      });
    }

    return total;
  };
  const ButtonClick = () => {
    setCouponCodeRemove("");
    setResetAmount(!resetAmount);
    localStorage.setItem("ResetAmount", JSON.stringify(!resetAmount));
    dispatch({ ResetAmount: !resetAmount });
    handleCheckOutAmount(paymentTypeId);
  };

  const finalTotal = calculateFinalTotal();

  return (
    <>
      <Paper style={{ padding: "20px", marginTop: "10px", position: "sticky", top: 0, width: "100%", maxHeight: "calc(150vh - 80px)", overflowY: "auto", boxShadow: "0 1px 2px 0 rgba(0,0,0,.25)", }}>
        <Typography variant="h4" style={{ color: "GrayText" }} gutterBottom>Order summary</Typography>
        <Typography variant="subtitle2" style={{ color: "GrayText", fontSize: "17px" }} gutterBottom>
          {
            checkOutDataEventDetail?.Event?.title ? (checkOutDataEventDetail?.Event?.title) : (<Skeleton variant="text" sx={{ fontSize: "1rem", width: "300px", marginTop: "7px" }} />)
          }
        </Typography>
        <List>
          {
            data?.final ? (data?.final?.map((product: any, index: number) => (
              <ListItem key={index} sx={{ py: 1, px: 0 }}>
                <div style={{ width: "50%", display: "flex", flexDirection: "row" }}>
                  <Typography variant="body2" sx={{ marginRight: 1 }}>
                    {product.ticketType}
                  </Typography>
                  <Typography>
                    {
                      product.price === 0 || null ? ("Free") : (<>$ <NumberFormat total={product.price} /></>)
                    }{" "}× {product.qty}
                  </Typography>
                </div>
                <div style={{ width: "50%", display: "flex", justifyContent: "end" }}>
                  <Typography variant="body2" sx={{ width: "50%" }} textAlign={"end"}>$ <NumberFormat total={product.amount} /></Typography>
                </div>
              </ListItem>
            ))
            ) : (
              <>
                <Skeleton variant="text" sx={{ fontSize: "1rem", width: "300px", marginTop: "7px" }} />
                <Skeleton variant="text" sx={{ fontSize: "1rem", width: "400px", marginTop: "7px" }} />
              </>
            )
          }
          <Divider sx={{ marginTop: 1 }} />
          {
            checkOutData?.subTotal ? (
              <ListItem sx={{ py: 1, px: 0 }}>
                <ListItemText primary="Sub Total" />
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>$ <NumberFormat total={checkOutData?.subTotal} /></Typography>
              </ListItem>
            ) : (<Skeleton variant="text" sx={{ fontSize: "1rem", width: "400px", marginTop: "25px" }} />)
          }

          {
            paymentTypeId === STRING.PAYMENT_TYPE_ID.ZELLE || paymentTypeId === STRING.PAYMENT_TYPE_ID.CARD ? (
              <>
                {checkOutData?.couponDiscountPrice > 0 ? (
                  <ListItem sx={{ py: 1, px: 0, display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body1">Coupon Discount ({couponInfo?.couponCode})</Typography>
                      <IconButton edge="end" sx={{ color: "red" }} aria-label="delete" onClick={ButtonClick}>
                        <CloseIcon />
                      </IconButton>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="body2" sx={{ display: "block", justifyContent: "flex-end", fontWeight: "600", color: "orangered" }}>
                        -${" "}<NumberFormat total={checkOutData?.couponDiscountPrice} />
                      </Typography>
                    </Box>
                  </ListItem>
                ) : null}
                {Array.isArray(checkOutData?.feeBreakdown) && checkOutData.feeBreakdown.length > 0 ? (
                  <>
                    {/* Visible non-tax fees (bundle any hidden charges into the primary service fee so no hidden fee is ever shown separately) */}
                    {(() => {
                      const visibleFees = checkOutData.feeBreakdown.filter(
                        (f: any) => f.isVisible && !f.isTax && Number(f.amount) > 0
                      );
                      const hiddenSum = checkOutData.feeBreakdown
                        .filter((f: any) => !f.isVisible && !f.isTax && Number(f.amount) > 0)
                        .reduce((sum: number, f: any) => sum + Number(f.amount), 0);

                      const baseFee = visibleFees.find((f: any) => f.id === "base_ticket_fee") || visibleFees[0];

                      return visibleFees.map((fee: any) => {
                        const displayAmount = (fee === baseFee && hiddenSum > 0)
                          ? Number(fee.amount) + hiddenSum
                          : Number(fee.amount);

                        return (
                          <ListItem key={fee.id} sx={{ py: 0.75, px: 0 }}>
                            <ListItemText primary={fee.name} />
                            <Typography>$ <NumberFormat total={displayAmount} /></Typography>
                          </ListItem>
                        );
                      });
                    })()}

                    {/* Tax */}
                    {checkOutData?.tax ? (
                      <ListItem sx={{ py: 0.75, px: 0 }}>
                        <ListItemText
                          primary={
                            checkOutData.feeBreakdown.find((f: any) => f.isTax)?.name || "Tax"
                          }
                        />
                        <Typography>$ <NumberFormat total={checkOutData?.tax} /></Typography>
                      </ListItem>
                    ) : null}
                  </>
                ) : (
                  <>
                    {checkOutData?.tax ? (
                      <ListItem sx={{ py: 1, px: 0 }}>
                        <ListItemText primary="Tax" />
                        <Typography>$ <NumberFormat total={checkOutData?.tax} /></Typography>
                      </ListItem>
                    ) : null}

                    {checkOutData?.serviceFees ? (
                      <ListItem sx={{ py: 1, px: 0 }}>
                        <ListItemText primary="Service Fee" />
                        <Typography>$ <NumberFormat total={checkOutData?.serviceFees} /></Typography>
                      </ListItem>
                    ) : null}
                  </>
                )}

                <Divider sx={{ marginTop: 1 }} />

                {
                  state?.showSkeleton ? (
                    <ListItem sx={{ py: 1, px: 0 }}>
                      <ListItemText primary="Total" />
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        ${" "}<NumberFormat total={checkOutData?.totalTicketPrices !== 0 ? checkOutData?.totalTicketPrices : finalTotal} />
                      </Typography>
                    </ListItem>
                  ) : (<Skeleton variant="text" sx={{ fontSize: "1rem", width: "435px", marginTop: "7px" }} />)
                }
              </>
            ) : (
              <>
                {
                  checkOutData?.couponDiscountPrice > 0 ? (
                    <ListItem sx={{ py: 1, px: 0, display: "flex", justifyContent: "space-between" }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body1">Coupon Discount ({couponInfo?.couponCode})</Typography>
                        <IconButton edge="end" sx={{ color: "red" }} aria-label="delete" onClick={ButtonClick}>
                          <CloseIcon />
                        </IconButton>
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="body2" sx={{ display: "block", justifyContent: "flex-end", fontWeight: "600", color: "orangered" }}>
                          -${" "}<NumberFormat total={checkOutData?.couponDiscountPrice} />
                        </Typography>
                      </Box>
                    </ListItem>
                  ) : null
                }
                <Divider sx={{ marginTop: 1 }} />
                {
                  state?.showSkeleton ? (
                    <ListItem sx={{ py: 1, px: 0 }}>
                      <ListItemText primary="Total" />
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        ${" "}<NumberFormat total={checkOutData?.totalTicketPrices !== 0 ? checkOutData?.totalTicketPrices : finalTotal} />
                      </Typography>
                    </ListItem>
                  ) : (<Skeleton variant="text" sx={{ fontSize: "1rem", width: "435px", marginTop: "7px" }} />)
                }
              </>
            )}
        </List>
      </Paper>
    </>
  );
}
interface ReviewProps {
  data?: any;
}
